import { BrowserHistory, createBrowserHistory } from 'history';

const customHistory: BrowserHistory = createBrowserHistory();

export default customHistory;
